import { Card, CardContent, Divider, Skeleton, Stack } from "@mui/material";

const FormSubmissionPropertiesSkeleton = () => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={0.5} divider={<Divider variant="dashed" />}>
          <Skeleton variant="rectangular" height={28} width={250} />
          <Skeleton variant="rectangular" height={24} width={150} />
          <Skeleton variant="rectangular" height={24} width={200} />
        </Stack>
      </CardContent>
    </Card>
  );
};

export { FormSubmissionPropertiesSkeleton };
